
import ContactNavbar from './components/ContactNavbar';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import QuoteForm from './components/QuoteForm';
import ContactFooter from './components/ContactFooter';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <ContactNavbar />
      <ContactHero />
      <ContactInfo />
      <QuoteForm />
      <ContactFooter />
    </div>
  );
}
